import { MalgaTokenization } from '@malga/tokenization'

import { showMessage, toast } from '../components/message'
import { getUrlAction, sentryError } from '../utils'
import { chamaEnsureMalgaCustomer, solicitaDadosFaltantesMalga } from './malgaHelpers'

const select = (seletor, wrapper) => (wrapper || document).querySelector(seletor)

function carregaConfigSDK() {
  return new Promise((resolve) => {
    $.ajax({
      url: getUrlAction('pedido', 'GetMalgaSDKConfig'),
      type: 'GET',
      success: (raw) => {
        try {
          const data = typeof raw === 'string' ? JSON.parse(raw) : raw
          resolve(data && data.lValid ? data.ret : null)
        } catch (e) {
          sentryError && sentryError(e)
          resolve(null)
        }
      },
      error: () => resolve(null),
    })
  })
}

function carregaStatusCliente() {
  return new Promise((resolve) => {
    $.ajax({
      url: getUrlAction('pedido', 'GetStatusClienteMalga'),
      type: 'GET',
      success: (raw) => {
        try {
          const data = typeof raw === 'string' ? JSON.parse(raw) : raw
          resolve(data && data.lValid ? data.ret : null)
        } catch {
          resolve(null)
        }
      },
      error: () => resolve(null),
    })
  })
}

async function garanteCadastroMalga() {
  let result = await chamaEnsureMalgaCustomer()

  while (!result.ok && result.missingFields && result.missingFields.length > 0) {
    const updated = await solicitaDadosFaltantesMalga(result.missingFields)
    if (!updated.ok) {
      return false
    }
    result = updated
  }

  return !!result.ok
}

function mensagemErroTokenizacao(error) {
  const fallback = 'Dados do cartão inválidos. Confira número, validade e CVV.'
  const sandboxHint = ' Em sandbox, use 4111 1111 1111 1111, validade futura e CVV terminado em 0, por exemplo 120.'

  const message =
    error?.error?.message ||
    error?.message ||
    error?.errorMessage ||
    error?.data?.error?.message ||
    error?.data?.message ||
    (typeof error === 'string' ? error : '')

  if (!message || /Cannot read properties of undefined|processing tokenize/i.test(message)) {
    return fallback + sandboxHint
  }

  if (/invalid|cvv|number|expiration|card|cart/i.test(message)) {
    return message + sandboxHint
  }

  return message
}

function ensureMalgaCardStyles() {
  if (document.getElementById('malga-card-form-styles')) return

  const styles = document.createElement('style')
  styles.id = 'malga-card-form-styles'
  styles.textContent = `
    #malga-card-form {
      padding: 0;
      background: rgba(17, 24, 39, 0.62);
      backdrop-filter: blur(3px);
      align-items: flex-end;
    }

    #malga-card-form .malga-card-modal {
      width: 100%;
      max-width: none;
      max-height: 100dvh;
      overflow-y: auto;
      padding: 14px;
      border-radius: 12px 12px 0 0;
      background: #ffffff;
      box-shadow: 0 20px 55px rgba(15, 23, 42, 0.24);
      display: flex;
      flex-direction: column;
      gap: 11px;
      animation: malga-sheet-up 0.24s cubic-bezier(0.2, 0.85, 0.32, 1) both;
    }

    @keyframes malga-sheet-up {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    #malga-card-form .malga-card-header {
      display: grid;
      grid-template-columns: 36px 1fr;
      gap: 10px;
      align-items: center;
    }

    #malga-card-form .malga-card-icon {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eef7f3;
      color: #167c59;
    }

    #malga-card-form .malga-card-title {
      margin: 0;
      color: #111827;
      font-size: 17px;
      font-weight: 700;
      line-height: 1.2;
      letter-spacing: 0;
    }

    #malga-card-form .malga-card-subtitle {
      margin: 3px 0 0;
      color: #64748b;
      font-size: 12px;
      line-height: 1.25;
    }

    #malga-card-form .malga-card-security {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 10px;
      border: 1px solid #dcebe5;
      border-radius: 8px;
      background: #f7fbf9;
      color: #315f4f;
      font-size: 12px;
      line-height: 1.25;
    }

    #malga-card-form .malga-card-fields {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    #malga-card-form .malga-card-row {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(110px, 0.78fr);
      gap: 10px;
    }

    #malga-card-form .malga-card-label {
      display: flex;
      flex-direction: column;
      gap: 6px;
      color: #1f2937;
      font-size: 12px;
      font-weight: 600;
    }

    #malga-card-form .malga-field,
    #malga-card-form .malga-hosted-field {
      height: 46px;
      min-height: 46px;
      max-height: 46px;
      border: 1px solid #d7dde5;
      border-radius: 6px;
      background: #ffffff;
      padding: 0 12px;
      display: flex;
      align-items: center;
      overflow: hidden;
      box-sizing: border-box;
      transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
    }

    #malga-card-form .malga-field iframe,
    #malga-card-form .malga-hosted-field iframe,
    #malga-card-form .malga-field > div,
    #malga-card-form .malga-hosted-field > div {
      width: 100% !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      display: block;
    }

    #malga-card-form .malga-field:hover,
    #malga-card-form .malga-hosted-field:hover {
      border-color: #b7c2d0;
      background: #ffffff;
    }

    #malga-card-form .malga-hosted-field-focused {
      border-color: #2d6cdf;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(45, 108, 223, 0.12);
    }

    #malga-card-form .malga-hosted-field-valid {
      border-color: #17a673;
    }

    #malga-card-form .malga-hosted-field-invalid {
      border-color: #d93025;
      box-shadow: 0 0 0 3px rgba(217, 48, 37, 0.08);
    }

    #malga-card-form .malga-save-option {
      display: flex;
      gap: 10px;
      align-items: flex-start;
      padding: 9px 10px;
      border: 1px solid #e5eaf0;
      border-radius: 8px;
      background: #ffffff;
      color: #344054;
      font-size: 13px;
      line-height: 1.35;
      cursor: pointer;
    }

    #malga-card-form .malga-save-option input {
      width: 16px;
      height: 16px;
      margin: 1px 0 0;
      accent-color: #2d6cdf;
      flex: 0 0 auto;
    }

    #malga-card-form .malga-save-option strong {
      display: block;
      color: #1f2937;
      font-size: 13px;
      font-weight: 600;
    }

    #malga-card-form .malga-save-option span {
      display: block;
      margin-top: 2px;
      color: #667085;
      font-size: 12px;
    }

    #malga-card-form .malga-card-error {
      display: none;
      padding: 9px 10px;
      border-radius: 6px;
      background: #fff1f0;
      color: #b42318;
      font-size: 12px;
      line-height: 1.35;
    }

    #malga-card-form .malga-card-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding-top: 1px;
    }

    #malga-card-form .malga-card-button {
      min-height: 42px;
      border-radius: 6px;
      padding: 0 16px;
      border: 1px solid transparent;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
      transition: transform 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
    }

    #malga-card-form .malga-card-button:active {
      transform: translateY(1px);
    }

    #malga-card-form .malga-card-button-secondary {
      background: #ffffff;
      border-color: #d7dde5;
      color: #344054;
    }

    #malga-card-form .malga-card-button-primary {
      background: #2d6cdf;
      color: #ffffff;
      box-shadow: 0 8px 18px rgba(45, 108, 223, 0.24);
    }

    #malga-card-form .malga-card-button-primary:hover {
      background: #245bbb;
    }

    #malga-card-form .malga-card-button:disabled {
      cursor: wait;
      opacity: 0.68;
      transform: none;
      box-shadow: none;
    }

    #malga-card-form .malga-card-body {
      position: relative;
    }

    #malga-card-form .malga-card-skeleton {
      position: absolute;
      inset: 0;
      z-index: 3;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    #malga-card-form .malga-sk-line,
    #malga-card-form .malga-sk-field,
    #malga-card-form .malga-sk-save {
      border-radius: 6px;
      background: linear-gradient(90deg, #eef1f5 25%, #e2e7ee 37%, #eef1f5 63%);
      background-size: 400% 100%;
      animation: malga-sk-shimmer 1.4s ease infinite;
    }

    #malga-card-form .malga-sk-label {
      height: 12px;
      width: 38%;
    }

    #malga-card-form .malga-sk-field {
      height: 46px;
    }

    #malga-card-form .malga-sk-row {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(110px, 0.78fr);
      gap: 10px;
    }

    #malga-card-form .malga-sk-col {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    #malga-card-form .malga-sk-save {
      height: 56px;
    }

    @keyframes malga-sk-shimmer {
      0% { background-position: 100% 0; }
      100% { background-position: 0 0; }
    }

    @media (prefers-reduced-motion: reduce) {
      #malga-card-form .malga-sk-line,
      #malga-card-form .malga-sk-field,
      #malga-card-form .malga-sk-save {
        animation: none;
      }
    }

    @media (max-width: 420px) {
      #malga-card-form {
        align-items: flex-end;
        padding: 0;
      }

      #malga-card-form .malga-card-modal {
        width: 100%;
        max-height: 100dvh;
        padding: 14px 14px 12px;
      }

      #malga-card-form .malga-card-row {
        grid-template-columns: 1fr 0.78fr;
      }

      #malga-card-form .malga-card-actions {
        flex-direction: column-reverse;
      }

      #malga-card-form .malga-card-button {
        width: 100%;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      #malga-card-form .malga-card-modal {
        animation: none;
      }
    }

    #malga-senha-dialog {
      padding: 0;
      align-items: flex-end;
      background: rgba(17, 24, 39, 0.62);
      backdrop-filter: blur(3px);
    }

    #malga-senha-dialog .malga-mobile-dialog {
      width: 100%;
      max-width: none;
      max-height: 100dvh;
      overflow-y: auto;
      padding: 14px;
      border-radius: 12px 12px 0 0;
      background: #ffffff;
      box-shadow: 0 20px 55px rgba(15, 23, 42, 0.24);
      display: flex;
      flex-direction: column;
      gap: 11px;
      animation: malga-sheet-up 0.24s cubic-bezier(0.2, 0.85, 0.32, 1) both;
    }

    #malga-senha-dialog .malga-mobile-title {
      margin: 0;
      color: #111827;
      font-size: 17px;
      font-weight: 700;
      line-height: 1.2;
    }

    #malga-senha-dialog .malga-mobile-text {
      margin: 0;
      color: #64748b;
      font-size: 12px;
      line-height: 1.3;
    }

    #malga-senha-dialog .malga-mobile-dialog > strong {
      color: #111827;
      font-size: 17px !important;
      font-weight: 700;
      line-height: 1.2;
    }

    #malga-senha-dialog .malga-mobile-dialog > span {
      color: #64748b !important;
      font-size: 12px !important;
      line-height: 1.3;
    }

    #malga-senha-dialog .malga-mobile-label {
      display: flex;
      flex-direction: column;
      gap: 6px;
      color: #1f2937;
      font-size: 12px;
      font-weight: 600;
    }

    #malga-senha-dialog .malga-mobile-input {
      height: 46px;
      border: 1px solid #d7dde5;
      border-radius: 6px;
      background: #ffffff;
      padding: 0 12px;
      color: #111827;
      font-size: 15px;
      font-weight: 500;
      outline: none;
    }

    #malga-senha-dialog input[type="password"] {
      width: 100%;
      height: 46px !important;
      border: 1px solid #d7dde5 !important;
      border-radius: 6px !important;
      background: #ffffff;
      padding: 0 12px !important;
      color: #111827;
      font-size: 15px;
      font-weight: 500;
      outline: none;
    }

    #malga-senha-dialog .malga-mobile-input:focus {
      border-color: #2d6cdf;
      box-shadow: 0 0 0 3px rgba(45, 108, 223, 0.12);
    }

    #malga-senha-dialog .malga-mobile-error {
      display: none;
      padding: 9px 10px;
      border-radius: 6px;
      background: #fff1f0;
      color: #b42318;
      font-size: 12px;
      line-height: 1.35;
    }

    #malga-senha-dialog .malga-mobile-actions {
      display: flex;
      flex-direction: column-reverse;
      gap: 8px;
    }

    #malga-senha-dialog .malga-card-button {
      width: 100%;
      min-height: 42px;
      border-radius: 6px;
      padding: 0 16px;
      border: 1px solid transparent;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
    }

    #malga-senha-dialog .malga-card-button-secondary {
      background: #ffffff;
      border-color: #d7dde5;
      color: #344054;
    }

    #malga-senha-dialog .malga-card-button-primary {
      background: #2d6cdf;
      color: #ffffff;
      box-shadow: 0 8px 18px rgba(45, 108, 223, 0.24);
    }

    #malga-senha-dialog #malga-senha-cancelar,
    #malga-senha-dialog #malga-senha-salvar {
      width: 100%;
      min-height: 42px;
      border-radius: 6px !important;
      padding: 0 16px !important;
      font-size: 13px;
      font-weight: 700;
    }

    #malga-senha-dialog #malga-senha-cancelar {
      border: 1px solid #d7dde5 !important;
      background: #ffffff !important;
      color: #344054;
    }

    #malga-senha-dialog #malga-senha-salvar {
      border: 1px solid transparent !important;
      background: #2d6cdf !important;
      color: #ffffff !important;
      box-shadow: 0 8px 18px rgba(45, 108, 223, 0.24);
    }
  `
  document.head.appendChild(styles)
}

/**
 * Dialog pedindo senha (6+ chars) para clientes que entraram via login rápido
 * e agora querem salvar cartão. Persiste via POST /Pedido/DefinirSenhaCliente.
 * Resolve true se salvou, false se cancelou.
 */
function solicitaSenha() {
  return new Promise((resolve) => {
    ensureMalgaCardStyles()

    const overlay = document.createElement('div')
    overlay.className = 'message-box'
    overlay.id = 'malga-senha-dialog'
    overlay.innerHTML = `
      <div class="message-box-content malga-mobile-dialog" role="dialog" aria-modal="true" aria-labelledby="malga-senha-title">
        <strong style="font-size:16px;">Crie uma senha para salvar o cartão</strong>
        <span style="font-size:12px;color:#6b6b6b;">
          Você entrou rápido pelo telefone. Pra manter o cartão salvo com segurança,
          defina uma senha da sua conta agora (mínimo 6 caracteres).
        </span>
        <label style="display:flex;flex-direction:column;gap:4px;font-size:12px;">
          Senha
          <input id="malga-senha" type="password" minlength="6"
            style="border:1px solid #dbdbdb;border-radius:4px;height:36px;padding:6px 10px;" />
        </label>
        <label style="display:flex;flex-direction:column;gap:4px;font-size:12px;">
          Confirmar senha
          <input id="malga-senha-conf" type="password" minlength="6"
            style="border:1px solid #dbdbdb;border-radius:4px;height:36px;padding:6px 10px;" />
        </label>
        <div id="malga-senha-erro" style="display:none;font-size:12px;color:#d93025;"></div>
        <div style="display:flex;gap:8px;justify-content:flex-end;margin-top:4px;">
          <button type="button" id="malga-senha-cancelar" style="padding:9px 14px;border:1px solid #dbdbdb;border-radius:4px;background:#fff;">Cancelar</button>
          <button type="button" id="malga-senha-salvar" style="padding:9px 14px;border:none;border-radius:4px;background:#3d5af1;color:#fff;">Salvar senha</button>
        </div>
      </div>`
    document.body.appendChild(overlay)

    const close = () => overlay.remove()
    const showErr = (m) => {
      const box = select('#malga-senha-erro', overlay)
      box.textContent = m
      box.style.display = 'block'
    }
    const hideErr = () => {
      const box = select('#malga-senha-erro', overlay)
      if (box) box.style.display = 'none'
    }

    select('#malga-senha-cancelar', overlay).addEventListener('click', () => {
      close()
      resolve(false)
    })

    select('#malga-senha-salvar', overlay).addEventListener('click', () => {
      hideErr()
      const senha = select('#malga-senha', overlay).value || ''
      const conf = select('#malga-senha-conf', overlay).value || ''
      if (senha.length < 6) return showErr('Senha deve ter no mínimo 6 caracteres.')
      if (senha !== conf) return showErr('Senhas não conferem.')

      const btn = select('#malga-senha-salvar', overlay)
      btn.setAttribute('disabled', 'true')
      btn.textContent = 'Salvando...'

      $.ajax({
        url: getUrlAction('pedido', 'DefinirSenhaCliente'),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ Senha: senha, ConfirmarSenha: conf }),
        success: (raw) => {
          try {
            const data = typeof raw === 'string' ? JSON.parse(raw) : raw
            if (data && data.lValid) {
              close()
              resolve(true)
            } else {
              showErr((data && data.msg) || 'Erro ao salvar senha.')
              btn.removeAttribute('disabled')
              btn.textContent = 'Salvar senha'
            }
          } catch {
            showErr('Erro inesperado.')
            btn.removeAttribute('disabled')
            btn.textContent = 'Salvar senha'
          }
        },
        error: () => {
          showErr('Falha ao contactar servidor.')
          btn.removeAttribute('disabled')
          btn.textContent = 'Salvar senha'
        },
      })
    })
  })
}

/**
 * Espera os iframes seguros da Malga montarem dentro dos containers antes de
 * esconder o skeleton. Resolve quando o iframe do número do cartão aparece, ou
 * por timeout (pra nunca pendurar a revelação se o SDK não montar nada).
 */
function aguardaCamposMalga(overlay, timeoutMs = 5000) {
  return new Promise((resolve) => {
    const alvo = select('#card-number', overlay)
    const pronto = () => !!(alvo && alvo.querySelector('iframe'))
    if (pronto()) return resolve()

    let finalizado = false
    const fim = () => {
      if (finalizado) return
      finalizado = true
      obs && obs.disconnect()
      resolve()
    }

    const obs = new MutationObserver(() => { if (pronto()) fim() })
    obs.observe(alvo || overlay, { childList: true, subtree: true })
    setTimeout(fim, timeoutMs)
  })
}

// Guarda contra cliques múltiplos: enquanto um form está abrindo/aberto, novos
// cliques no botão "Adicionar cartão" viram no-op (evita N modais e N chamadas
// de GetMalgaSDKConfig empilhadas).
let _abrindoFormCartao = false

/**
 * Abre form de cartão com iframes seguros da Malga + checkbox "Salvar cartão".
 * O modal aparece na hora com skeleton loader enquanto o SDK config carrega.
 * Resolve:
 *   - { ok: true, card: {cardId, brand, last4} } quando salvou
 *   - { ok: true, temp: {tokenId, last4, brand} } quando tokenizou sem salvar
 *     (tokenId one-shot, usar na próxima cobrança e descartar)
 *   - { ok: false } quando cancelou / erro
 */
export async function abreFormCartaoMalga() {
  if (_abrindoFormCartao) return { ok: false }
  _abrindoFormCartao = true

  return new Promise((resolve) => {
    ensureMalgaCardStyles()

    const overlay = document.createElement('div')
    overlay.className = 'message-box'
    overlay.id = 'malga-card-form'
    overlay.innerHTML = `
      <div class="message-box-content malga-card-modal" role="dialog" aria-modal="true" aria-labelledby="malga-card-title">
        <div class="malga-card-header">
          <div class="malga-card-icon" aria-hidden="true">
            <svg width="23" height="23" viewBox="0 0 24 24" fill="none">
              <path d="M4.75 7.25C4.75 6.42157 5.42157 5.75 6.25 5.75H17.75C18.5784 5.75 19.25 6.42157 19.25 7.25V16.75C19.25 17.5784 18.5784 18.25 17.75 18.25H6.25C5.42157 18.25 4.75 17.5784 4.75 16.75V7.25Z" stroke="currentColor" stroke-width="1.6"/>
              <path d="M4.75 9.25H19.25" stroke="currentColor" stroke-width="1.6"/>
              <path d="M7.75 14.75H10.75" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
          </div>
          <div>
            <h2 class="malga-card-title" id="malga-card-title">Adicionar cartão de crédito</h2>
            <p class="malga-card-subtitle">Preencha os dados para usar este cartão no pagamento online.</p>
          </div>
        </div>

        <div class="malga-card-security">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4.25 7V5.75C4.25 3.67893 5.92893 2 8 2C10.0711 2 11.75 3.67893 11.75 5.75V7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
            <path d="M3.75 7.25H12.25V13.25H3.75V7.25Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
          </svg>
          <span>Processamento seguro pela Malga. O Mogo não armazena o número do cartão.</span>
        </div>

        <div class="malga-card-body">
          <div id="malga-card-skeleton" class="malga-card-skeleton" aria-hidden="true">
            <div class="malga-sk-line malga-sk-label"></div>
            <div class="malga-sk-field"></div>
            <div class="malga-sk-row">
              <div class="malga-sk-col">
                <div class="malga-sk-line malga-sk-label"></div>
                <div class="malga-sk-field"></div>
              </div>
              <div class="malga-sk-col">
                <div class="malga-sk-line malga-sk-label"></div>
                <div class="malga-sk-field"></div>
              </div>
            </div>
            <div class="malga-sk-line malga-sk-label"></div>
            <div class="malga-sk-field"></div>
            <div class="malga-sk-save"></div>
          </div>

          <div id="malga-alias-wrapper" style="display:none; flex-direction:column; gap:6px;">
            <label style="color:#1f2937; font-size:12px; font-weight:600;">
              Apelido do cartão (opcional)
            </label>
            <input
              type="text"
              id="malga-card-alias"
              maxlength="100"
              placeholder="Ex: Meu Nubank, Cartão da empresa"
              class="malga-missing-input"
              style="height:44px; border:1px solid #d7dde5; border-radius:6px; background:#fff; padding:0 12px; color:#111827; font-size:14px; font-weight:500; outline:none;"
            />
          </div>

          <div class="malga-card-fields">
            <label class="malga-card-label">
              Número do cartão
              <div id="card-number" class="malga-field"></div>
            </label>

            <div class="malga-card-row">
              <label class="malga-card-label">
                Validade
                <div id="card-expiration-date" class="malga-field"></div>
              </label>
              <label class="malga-card-label">
                CVV
                <div id="card-cvv" class="malga-field"></div>
              </label>
            </div>

            <label class="malga-card-label">
              Nome impresso no cartão
              <div id="card-holder-name" class="malga-field"></div>
            </label>
          </div>

          <label class="malga-save-option">
            <input type="checkbox" id="malga-save-card" />
            <span>
              <strong>Salvar cartão</strong>
              <span>Use novamente em compras futuras sem redigitar os dados.</span>
            </span>
          </label>
        </div>

        <div id="malga-card-error" class="malga-card-error"></div>

        <div class="malga-card-actions">
          <button type="button" id="malga-card-cancelar" class="malga-card-button malga-card-button-secondary">Cancelar</button>
          <button type="button" id="malga-card-salvar" class="malga-card-button malga-card-button-primary" disabled>Continuar</button>
        </div>
      </div>`
    document.body.appendChild(overlay)

    let finalizado = false
    const finish = (result) => {
      if (finalizado) return
      finalizado = true
      _abrindoFormCartao = false
      resolve(result)
    }
    const close = () => overlay.remove()
    const showErr = (m) => {
      const box = select('#malga-card-error', overlay)
      if (box) { box.textContent = m; box.style.display = 'block' }
    }
    const hideErr = () => {
      const box = select('#malga-card-error', overlay)
      if (box) box.style.display = 'none'
    }

    const btnSalvar = select('#malga-card-salvar', overlay)

    // Cancelar já funciona durante o carregamento (fecha modal + libera a guarda).
    select('#malga-card-cancelar', overlay).addEventListener('click', () => {
      close()
      finish({ ok: false })
    })

    // Config + SDK carregam em background; o modal já está visível com skeleton.
    ;(async () => {
      const sdkConfig = await carregaConfigSDK()
      if (finalizado) return // usuário cancelou enquanto carregava
      if (!sdkConfig || !sdkConfig.clientId || !sdkConfig.apiKey) {
        close()
        showMessage(
          'Pagamento online',
          'Integração Malga não configurada.',
          'warning',
          'Entendi',
          () => {
            const btn = select('.message-box button')
            btn && $(btn).on('click', () => select('.message-box').remove())
          },
        )
        finish({ ok: false })
        return
      }

      let tokenizer
      try {
        tokenizer = new MalgaTokenization({
          apiKey: sdkConfig.apiKey,
          clientId: sdkConfig.clientId,
          options: {
            sandbox: !!sdkConfig.sandbox,
            config: {
              fields: {
                cardNumber: { container: 'card-number', placeholder: '0000 0000 0000 0000' },
                cardHolderName: { container: 'card-holder-name', placeholder: 'NOME COMPLETO' },
                cardCvv: { container: 'card-cvv', placeholder: '123' },
                cardExpirationDate: { container: 'card-expiration-date', placeholder: 'MM/AA' },
              },
              styles: {
                input: {
                  color: '#111827',
                  'font-size': '15px',
                  'font-family': '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  'font-weight': '500',
                  'line-height': '44px',
                  height: '44px',
                  padding: '0',
                  'background-color': '#ffffff',
                  'letter-spacing': '0',
                },
                ':focus': {
                  color: '#111827',
                },
                placeholder: {
                  color: '#64748b',
                  'font-size': '15px',
                  'font-family': '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  'font-weight': '500',
                  'letter-spacing': '0',
                },
                '::placeholder': {
                  color: '#64748b',
                  'font-size': '15px',
                  'font-family': '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  'font-weight': '500',
                  'letter-spacing': '0',
                },
              },
              preventAutofill: true,
            },
          },
        })
      } catch (e) {
        sentryError && sentryError(e)
        close()
        toast && toast('Não foi possível iniciar o cartão.', 'error')
        finish({ ok: false })
        return
      }

      // Espera os iframes montarem e só então esconde o skeleton e libera o botão.
      await aguardaCamposMalga(overlay)
      if (finalizado) return
      const skeleton = select('#malga-card-skeleton', overlay)
      if (skeleton) skeleton.remove()
      btnSalvar.removeAttribute('disabled')

      const saveCardCheckbox = select('#malga-save-card', overlay)
      const aliasWrapper = select('#malga-alias-wrapper', overlay)

      saveCardCheckbox.addEventListener('change', () => {
        if (aliasWrapper) {
          aliasWrapper.style.display = saveCardCheckbox.checked ? 'flex' : 'none'
        }
      })

      btnSalvar.addEventListener('click', async () => {
      hideErr()
      const saveCard = !!select('#malga-save-card', overlay).checked
      const btn = select('#malga-card-salvar', overlay)
      btn.setAttribute('disabled', 'true')
      btn.textContent = 'Processando...'

      // Quando for salvar e cliente não tem senha, pede senha antes de tokenizar.
      // Se usuário cancelar o dialog de senha, desliga a flag e segue apenas com token
      // one-shot (pra não perder os dados já digitados).
      let saveCardFinal = saveCard
      if (saveCardFinal) {
        const status = await carregaStatusCliente()
        if (status && !status.temSenha) {
          const senhaOk = await solicitaSenha()
          if (!senhaOk) {
            saveCardFinal = false
            toast && toast('Prossiga apenas com esta compra; cartão não será salvo.', 'info')
          }
        }
      }

      const cadastroOk = await garanteCadastroMalga()
      if (!cadastroOk) {
        showErr('Complete seu cadastro para continuar o pagamento online.')
        btn.removeAttribute('disabled')
        btn.textContent = 'Continuar'
        return
      }

      try {
        // tokenizer.tokenize() do SDK da Malga pode pendurar a Promise (não resolve
        // nem rejeita) — sem timeout, o botão trava em "Processando..." e a tela
        // congela. Promise.race garante que sempre termine: ou tokeniza, ou rejeita
        // em 30s e cai no catch (botão reabilitado, erro exibido).
        const tokenResp = await Promise.race([
          tokenizer.tokenize(),
          new Promise((_, reject) =>
            setTimeout(
              () => reject(new Error('Tempo esgotado ao processar o cartão. Verifique sua conexão e tente novamente.')),
              30000,
            ),
          ),
        ])
        if (!tokenResp || tokenResp.error) {
          showErr(mensagemErroTokenizacao(tokenResp?.error || tokenResp))
          btn.removeAttribute('disabled')
          btn.textContent = 'Continuar'
          return
        }
        const tokenId = tokenResp.tokenId
        if (!tokenId) {
          showErr('Não foi possível tokenizar o cartão.')
          btn.removeAttribute('disabled')
          btn.textContent = 'Continuar'
          return
        }

        if (!saveCardFinal) {
          // Token one-shot — cliente vai usar na cobrança desse pedido e não
          // persiste cartão. Retornamos tokenId pro chamador guardar em
          // storeOrder.malgaTokenId.
          close()
          finish({ ok: true, temp: { tokenId } })
          return
        }

        // Salvar: promove tokenId em cardId persistente via backend.
        btn.textContent = 'Salvando...'
        const aliasInput = select('#malga-card-alias', overlay)
        const cardAlias = (aliasInput && aliasInput.value ? aliasInput.value.trim() : '')
        $.ajax({
          url: getUrlAction('pedido', 'SalvarCartaoMalga'),
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({ tokenId, alias: cardAlias }),
          success: (raw) => {
            try {
              const data = typeof raw === 'string' ? JSON.parse(raw) : raw
              if (data && data.lValid && data.ret && data.ret.cardId) {
                close()
                toast && toast('Cartão cadastrado com sucesso!', 'success')
                finish({ ok: true, card: data.ret })
              } else {
                if (data && data.missingFields && data.missingFields.length > 0) {
                  solicitaDadosFaltantesMalga(data.missingFields).then((updated) => {
                    if (updated && updated.ok) {
                      btn.removeAttribute('disabled')
                      btn.textContent = 'Continuar'
                      showErr('Cadastro atualizado. Clique em continuar para finalizar o cartão.')
                    } else {
                      showErr('Complete seu cadastro para salvar o cartão.')
                      btn.removeAttribute('disabled')
                      btn.textContent = 'Continuar'
                    }
                  })
                  return
                }
                showErr((data && data.msg) || 'Não foi possível salvar o cartão.')
                btn.removeAttribute('disabled')
                btn.textContent = 'Continuar'
              }
            } catch (e) {
              sentryError && sentryError(e)
              showErr('Erro inesperado ao salvar cartão.')
              btn.removeAttribute('disabled')
              btn.textContent = 'Continuar'
            }
          },
          error: () => {
            showErr('Falha ao salvar cartão. Tente novamente.')
            btn.removeAttribute('disabled')
            btn.textContent = 'Continuar'
          },
        })
      } catch (e) {
        sentryError && sentryError(e)
        showErr(mensagemErroTokenizacao(e))
        btn.removeAttribute('disabled')
        btn.textContent = 'Continuar'
      }
      })
    })()
  })
}
